import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import MenusOptionsList from "./MenusOptionList";
import useFetchList from "../../../utils/useFetchLIst";
// import useFetchList from "../../../utils/useFetchList";

const MenuAccessMaster = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    role: "",
  });
  const [selectedRoleId, setSelectedRoleId] = useState(null); // Add this line
  const [errors, setErrors] = useState({});
  const [usersOptions, setUsersOptions] = useState([]);
  const [showMenuOptions, setShowMenuOptions] = useState(false);
  const navigate = useNavigate();
  const schema = localStorage.getItem("schema");

  useEffect(() => {
    const storedData =
      JSON.parse(localStorage.getItem("selectedUserData")) || [];
    const foundCustomer = storedData.find(
      (customer) => customer.id === parseInt(id)
    );

    if (foundCustomer) {
      setFormData(foundCustomer);
    }
  }, [id]);

  const payload = {
    modelName: "role_masters",
    schema:schema,
    whereCondition: {
      is_active: true
    },

  };
  const { data: usersData } = useFetchList("/getRecords", payload);
  useEffect(() => {
    if (usersData) {
      const options = usersData.map((user) => ({
        value: user.id,
        label: user.role_name,
      }));
      setUsersOptions(options);
    }
  }, [usersData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};
    let valid = true;
    console.log("Selected role ID:", formData.role);
    if (!String(formData.role).trim()) {
      newErrors.role = "Role cannnot be blank.";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    }
    setSelectedRoleId(formData.role);
    // setFormData({
    //   role: "",
    // });
    //  navigate('/menu-access-masters/menus-access-list');
    setShowMenuOptions(true);
  };

  return (
    <>
      <div className="page-content">
        <Breadcrumbs title={"Menu Access"} breadcrumbItems={[]} />
        <div className="card mb-3">
          <div className="container-fluid p-4 ">
            <p className="text-muted pb-1">
              Fields marked with <span className="text-danger fw-bold">*</span>{" "}
              are required.
            </p>
            <form onSubmit={handleFormSubmit}>
              <div className="row mb-3 align-items-center">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label className="form-label custom-label">
                      Role <span className="text-danger">*</span>
                    </label>
                    <Select
                      className={`font-size-13 ${errors.role ? "is-invalid" : ""
                        }`}
                      options={usersOptions}
                      value={usersOptions.find(
                        (option) => option.value === formData.role
                      )}
                      onChange={(selectedOption) =>
                        handleChange({
                          target: {
                            name: "role",
                            value: selectedOption ? selectedOption.value : "",
                          },
                        })
                      }
                      placeholder="Select Role"
                      isSearchable
                      isClearable
                      onMenuOpen={() => { }}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: errors.role
                            ? "#dee2e6"
                            : base.borderColor,
                          boxShadow: errors.role
                            ? "0 0 0 0.5px red"
                            : base.boxShadow,
                          "&:hover": {
                            borderColor: errors.role
                              ? "#dee2e6"
                              : base.borderColor,
                          },
                        }),
                      }}
                    />
                    {errors.role && (
                      <div className="invalid-feedback">{errors.role}</div>
                    )}
                  </div>
                </div>
                <div className="col-6 mt-3 mb-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      width: "80px",
                      fontSize: "13px",
                    }}>
                    {id ? "Update" : "Go"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {showMenuOptions && <MenusOptionsList roleId={selectedRoleId} />}
      </div>
    </>
  );
};

export default MenuAccessMaster;
